const initState = {
  abpConfigList: {},
}
const Abp = {
  namespaced: true,
  state: {
    ..._.cloneDeep(initState)
  },
  mutations: {
    resetState(state) {
      _.assign(state, initState)
    },
    updateState(state, { payload }) {
      _.assign(state, payload)
    },
    abpConfigList(state, payload) {
      _.assign(state, {
        abpConfigList: payload,
      })
    },
  },
  getters: {
    abpConfigList(state) {
      return state.abpConfigList
    },
  },
  actions: {
    abpConfigList({ commit }, payload) {
      commit('abpConfigList', payload)
    },
  },
}

export default Abp
